import axios from "axios"
import library from "../../../utils/Library"

export const updateSubscriptionDelegationsVE = async (newData) => {
  const TOKEN = sessionStorage.getItem("token")

  const URL =
    library.getBaseAPIUrl("legal_communications") +
    "/updateSubscriptionDelegationsVE"

  return await axios(URL, {
    url: URL,
    method: "PATCH",
    data: newData,
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
